"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridNormalCell = void 0;
const react_1 = __importDefault(require("react"));
const GridNormalCell_1 = require("./components/GridNormalCell/GridNormalCell");
function gridNormalCell(config) {
    return function NormalCellRenderer({ rowData, column, disabled, inactive, loading }) {
        return (react_1.default.createElement(GridNormalCell_1.GridNormalCell, { content: loading ? null : config.value(rowData), columnId: column.id, justify: column.justify, columnWidth: column.width, disabled: disabled, inactive: inactive, loading: loading, highlighted: column.highlighted, hasBigLeftIntent: column.hasBigLeftIntent, hasPaddings: column.hasPaddings }));
    };
}
exports.gridNormalCell = gridNormalCell;
//# sourceMappingURL=gridNormalCellRenderer.js.map